import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/search/edit')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Skogeieropplysninger',
  },
})

function RouteComponent() {
  return <Outlet />
}
